/**
 * StayOn-Brand-Mark + Wordmark (Sprint-16-Brand).
 *
 * PowerMark = das ○-Glyph im Wordmark: Kreis + vertikaler Tick mit Cutout.
 * Visuelles Wortspiel — „stay on" + Power-Button — das Farbschema isoliert das
 * ○ vom Rest der Buchstaben damit die Doppelbedeutung sichtbar bleibt.
 *
 * Ring + Tick sind AMBER — Power-Button-„on/active"-Semantik (nicht sealwax:
 * sealwax = Danger würde die „staying on"-Bedeutung invertieren). Cutout
 * matched den Hintergrund (paper auf light, navy auf dark) damit der
 * Tick-Break sauber ausgestanzt wirkt.
 *
 * Wortlaute STAY + N nehmen die Ink-Farbe (light) oder Paper-Farbe (dark) —
 * neutrale Schrift, farbige Mark. Klassisches Editorial-Masthead-Pattern.
 */
import { cn } from '@/shared/lib/cn';

export interface PowerMarkProps {
  size?: number;
  className?: string;
  /** Ring + Tick Color. Default: sealwax (Brand-Signature). */
  color?: string;
  /** Cutout im Tick — matched den Hintergrund. Default: paper. */
  cutoutColor?: string;
}

export function PowerMark({
  size = 24,
  className,
  color = 'var(--color-amber)',
  cutoutColor = 'var(--color-paper)',
}: PowerMarkProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="16" cy="17" r="10.2" stroke={color} strokeWidth="2.4" />
      <rect x="14.85" y="5.2" width="2.3" height="11" rx="1.15" fill={color} />
      <rect x="14.85" y="5.2" width="2.3" height="4" rx="1.15" fill={cutoutColor} />
    </svg>
  );
}

export interface WordmarkProps {
  /** Font-Size in px. PowerMark wird proportional skaliert (1.0×). */
  size?: number;
  /** Variante für dunkle Surfaces (Sidebar-Navy). Default: false. */
  onDark?: boolean;
  className?: string;
}

export function Wordmark({ size = 22, onDark = false, className }: WordmarkProps) {
  const textColor = onDark ? 'var(--color-paper)' : 'var(--color-ink)';
  const cutoutColor = onDark ? 'var(--color-navy)' : 'var(--color-paper)';

  return (
    <span
      className={cn('inline-flex items-center font-sans font-bold', className)}
      style={{
        fontSize: size,
        letterSpacing: '0.02em',
        gap: 1,
        color: textColor,
        lineHeight: 1,
      }}
      aria-label="StayOn"
    >
      <span>STAY</span>
      <PowerMark size={size} color="var(--color-amber)" cutoutColor={cutoutColor} />
      <span>N</span>
    </span>
  );
}
